import { KrCard } from '@/common/card/KrCard';
import { Spacer } from '@/common/layout/SpacerLayout';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, LinearProgress, Stack, Typography } from '@mui/material';

export const TestKpiStrip = ({ tests, requirements, suites }) => {
  const allSuitesPass = suites.length > 0 && suites.every((s) => s.status === 'SUCCESS');
  const oneTestRan = tests.total !== 0;
  const suitePassCount = suites.filter((s) => s.status === 'SUCCESS').length;

  const reqCoverage = requirements.total > 0 ? (requirements.met / requirements.total) * 100 : 0;

  return (
    <>
      {/* KPI Cards */}
      <Spacer>
        {/* Overall Status */}
        <KrCard title="Overall Status" icon={allSuitesPass ? fas.faCircleCheck : oneTestRan ? fas.faCircleXmark : fas.faCircleMinus}>
          <Stack gap={1} height={'100%'}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                color: allSuitesPass ? 'success.main' : oneTestRan ? 'error.main' : 'text.secondary',
              }}
            >
              {allSuitesPass ? 'PASS' : oneTestRan ? 'FAIL' : 'N/A'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {suitePassCount} of {suites.length} suites passing
            </Typography>
          </Stack>
        </KrCard>

        {/* Test Results */}
        <KrCard title="Test Results" icon={fas.faVial}>
          <Box sx={{ display: 'flex', gap: 3 }}>
            {/* Pass */}
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, mb: 0.5 }}>
                <Typography variant="h4" sx={{ fontWeight: 700, color: 'success.main' }}>
                  {tests.pass}
                </Typography>
                <FontAwesomeIcon icon={fas.faCheck} style={{ fontSize: 14, color: '#2e7d32' }} />
              </Box>
              <Typography variant="caption" color="text.secondary">
                Passing
              </Typography>
            </Box>

            {/* Fail */}
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, mb: 0.5 }}>
                <Typography variant="h4" sx={{ fontWeight: 700, color: 'error.main' }}>
                  {tests.fail}
                </Typography>
                <FontAwesomeIcon icon={fas.faXmark} style={{ fontSize: 14, color: '#d32f2f' }} />
              </Box>
              <Typography variant="caption" color="text.secondary">
                Failing
              </Typography>
            </Box>

            {/* Not Run */}
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, mb: 0.5 }}>
                <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.secondary' }}>
                  {tests.notRun}
                </Typography>
                <FontAwesomeIcon icon={fas.faMinus} style={{ fontSize: 14, color: '#999' }} />
              </Box>
              <Typography variant="caption" color="text.secondary">
                Not Run
              </Typography>
            </Box>
          </Box>
        </KrCard>

        {/* Requirement Coverage */}
        <KrCard title="Requirement Coverage" icon={fas.faListCheck}>
          <Stack height={'100%'}>
            <Stack direction={'row'} alignItems={'baseline'} gap={1}>
              <Typography variant="h3" sx={{ fontWeight: 700 }}>
                {requirements.met}
              </Typography>
              <Typography variant="h5" color="text.secondary">
                / {requirements.total}
              </Typography>
            </Stack>

            <LinearProgress
              variant="determinate"
              value={reqCoverage}
              sx={{
                minHeight: 8,
                display: 'block',
                borderRadius: 1,
                bgcolor: 'grey.200',
                '& .MuiLinearProgress-bar': {
                  bgcolor: reqCoverage === 100 ? 'success.main' : 'primary.main',
                  borderRadius: 1,
                },
              }}
            />

            <Typography variant="caption" color="text.secondary">
              {reqCoverage.toFixed(1)}% coverage
            </Typography>
          </Stack>
        </KrCard>
      </Spacer>
    </>
  );
};
